import type { ShortcutDefinition } from '../types/shortcut-definition'

export const shortcuts = {
  generateRestoreVersion: {
    mac: [['mod', 'S']],
    windows: [['mod', 'S']],
  },
  undo: {
    mac: [['mod', 'Z']],
    windows: [['mod', 'Z']],
  },
  redo: {
    mac: [['mod', 'Y']],
    windows: [['mod', 'Y']],
  },
  cut: {
    mac: [['mod', 'X']],
    windows: [['mod', 'X']],
  },
  copy: {
    mac: [['mod', 'C']],
    windows: [['mod', 'C']],
  },
  duplicate: {
    mac: [['mod', 'D']],
    windows: [['mod', 'D']],
  },
  paste: {
    mac: [['mod', 'V']],
    windows: [['mod', 'V']],
  },
  pasteInPlace: {
    mac: [['mod', 'shift', 'V']],
    windows: [['mod', 'shift', 'V']],
  },
  delete: {
    mac: [['delete']],
    windows: [['delete']],
  },
  selectAll: {
    mac: [['mod', 'A']],
    windows: [['mod', 'A']],
  },
  selectNone: {
    mac: [['mod', 'shift', 'A']],
    windows: [['mod', 'shift', 'A']],
  },
  bringToFront: {
    mac: [['rightBracket']],
    windows: [['rightBracket']],
  },
  bringForward: {
    mac: [['mod', 'rightBracket']],
    windows: [['mod', 'rightBracket']],
  },
  sendBackward: {
    mac: [['mod', 'leftBracket']],
    windows: [['mod', 'leftBracket']],
  },
  sendToBack: {
    mac: [['leftBracket']],
    windows: [['leftBracket']],
  },
  group: {
    mac: [['mod', 'G']],
    windows: [['mod', 'G']],
  },
  ungroup: {
    mac: [['mod', 'shift', 'G']],
    windows: [['mod', 'shift', 'G']],
  },
  lock: {
    mac: [['mod', 'L']],
    windows: [['mod', 'L']],
  },
  unlock: {
    mac: [['mod', 'shift', 'L']],
    windows: [['mod', 'shift', 'L']],
  },
  toggleFreeze: {
    mac: [['mod', 'shift', 'F']],
    windows: [['mod', 'shift', 'F']],
  },
  zoomIn: {
    mac: [['plus'], ['equals'], ['mod', 'plus'], ['mod', 'equals']],
    windows: [['plus'], ['equals'], ['mod', 'plus'], ['mod', 'equals']],
  },
  zoomOut: {
    mac: [['minus'], ['mod', 'minus']],
    windows: [['minus'], ['mod', 'minus']],
  },
  actualSize: {
    mac: [['mod', '0']],
    windows: [['mod', '0']],
  },
  fitToSpread: {
    mac: [['mod', '1']],
    windows: [['mod', '1']],
  },
  zoomToSelection: {
    mac: [['mod', '2']],
    windows: [['mod', '2']],
  },
  pan: {
    mac: [['space']],
    windows: [['space']],
  },
  shortcuts: {
    mac: [['shift', 'slash']],
    windows: [['shift', 'slash']],
  },
} as const satisfies Record<string, ShortcutDefinition>
